// extracted by mini-css-extract-plugin
module.exports = {"refreshErrorPage":"style_refreshErrorPage__ZlfJ0","refreshErrorPageContent":"style_refreshErrorPageContent__2SvO6"};